import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Box, Stack, Typography} from '@mui/material';
import TextFieldComponent from '@components/inputs/textField/TextField.component';
import {
  executionsService,
  ExecutionStatus,
  ExecutionStatusHistory,
  ManageExecution
} from '@store/operations/executions';

interface StatusHistoryProps {
  execution: ManageExecution;
}

const StatusHistoryComponent = (props: StatusHistoryProps) => {
  const {execution} = props;
  const [statuses, setStatuses] = useState<ExecutionStatusHistory[]>([]);
  const {t} = useTranslation();

  useEffect(() => {
    if (execution.id) {
      executionsService.getExecutionHistory(execution.id).subscribe({
        next: setStatuses,
      });
    }

  }, [execution.id, execution.updatedAt]);

  return (
    <Stack py="20px" spacing={2}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography fontSize={16} fontWeight="700">
          {t('operations.executions.manage.history')}
        </Typography>
      </Stack>
      <Stack direction="column" spacing={2}>
        {statuses.map((s, index) =>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} key={index}>
            <Box flex={1}>
              <TextFieldComponent
                color="secondary"
                readOnly
                value={ExecutionStatus.selectItems().find(si => si.value === s.status)?.label || ''}/>
            </Box>
            <Stack direction="column" flex={1}>
              <Typography fontSize={14} fontWeight={400}>
                {s.author ? `${s.author?.firstName} ${s.author?.lastName}` : '-'}
              </Typography>
              <Typography fontSize={12} fontWeight={200}>
                {t('global.fullDateTime', {date: new Date(s.updatedAt)})}
              </Typography>
            </Stack>
          </Stack>)}
      </Stack>
    </Stack>
  );
};

export default StatusHistoryComponent;
